import { render, staticRenderFns } from "./CompletedTickets.vue?vue&type=template&id=6be4e54b&"
import script from "./CompletedTickets.vue?vue&type=script&lang=js&"
export * from "./CompletedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports